import $ from "jquery";
import Fuse from 'fuse.js'

$('.faq_question').on('click', function(){
  if($(this).hasClass('open')) {
    $(this).removeClass('open');
    $(this).next().slideUp();
  } else {
    $(this).addClass('open');
    $(this).next().slideDown();
  }
});

$('.faqs_categories select').on('change', function() {
  var val = $(this).val();
  if(val.length > 1) {
    $(".faq").removeClass('show');
    $(".faq[data-categories*='"+ val +"']").addClass('show');
  } else {
    $(".faq").addClass('show');
  }
});

if($('#faqs_json').length) {
  var questions = JSON.parse($('#faqs_json').attr('data-questions'));
  console.log('questions', questions);
  const fuse = new Fuse(questions, {
    keys: ['question', 'answer'],
    threshold: 0.2,
    includeScore: true,
    findAllMatches: true,
    ignoreLocation: true,
    // distance: 2000
  });


  $('.faq_search input').on('input', function() {
    var val = $(this).val();
    if(val.length >= 1) {
      $('.faqs_search_results h4 span').text('"' + val + '"');
      $('#faq-search-results').addClass('show');
    } else {
      $('.faqs_search_results h4 span').text("");
      $('#faq-search-results').removeClass('show');
    }
    var results = fuse.search(val);
    console.log('results', results);
    var ids = [];
    results.forEach(function(element){
      // console.log('element', element.item.id);
      ids.push(element.item.id);
    });
    
    $('.faqs_search_results .faq').each(function(){
      var id = parseInt($(this).attr('data-id'));
      if(ids.includes(id)) {
        $(this).addClass('show');
      } else {
        $(this).removeClass('show');
      }
    });
  });
}
